import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NoImageFoundDirective } from './directives/no-image-found/no-image-found.directive';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [NoImageFoundDirective],
  exports: [NoImageFoundDirective],
})
export class CoreFeaturesNoImageFoundModule {}
